// [EDITED: KPI Task - Mahesh Sharma]
import * as XLSX from 'xlsx'; // [EDITED: KPI Task - Mahesh Sharma]
import jsPDF from 'jspdf'; // [EDITED: KPI Task - Mahesh Sharma]
import autoTable from 'jspdf-autotable'; // [EDITED: KPI Task - Mahesh Sharma]
import { formatFYWeekLabel, formatFYWeekShort } from './fyWeekUtils'; // [EDITED: KPI Task - Mahesh Sharma]

/**
 * Exports KPI Tracker report to an Excel (.xlsx) file.
 * Automatically adapts columns whether from Admin Management view or Dashboard/Reports view.
 *
 * @param {Array} data - Array of submission/rating objects
 * @param {string} week - Target week string
 * @param {string} reportType - e.g. "KPI Submissions & Ratings Tracker"
 */
export function exportKPIToExcel(data = [], week = '', reportType = 'KPI Tracker Report') { // [EDITED: KPI Task - Mahesh Sharma]
  try { // [EDITED: KPI Task - Mahesh Sharma]
    const weekLabel = formatFYWeekLabel(week) || week || 'All Periods'; // [EDITED: KPI Task - Mahesh Sharma]
    
    if (!data || data.length === 0) { // [EDITED: KPI Task - Mahesh Sharma]
      alert('No data available to export'); // [EDITED: KPI Task - Mahesh Sharma]
      return false; // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]

    const isManagementView = data.length > 0 && ('employeeName' in data[0] || 'submissionDisplay' in data[0]); // [EDITED: KPI Task - Mahesh Sharma]

    let rows; // [EDITED: KPI Task - Mahesh Sharma]
    if (isManagementView) { // [EDITED: KPI Task - Mahesh Sharma]
      rows = data.map((item, index) => ({ // [EDITED: KPI Task - Mahesh Sharma]
        'S.No': index + 1, // [EDITED: KPI Task - Mahesh Sharma]
        'Week': (/^\d{4}-W\d{1,2}$/.test(String(item.week || '')) ? formatFYWeekLabel(item.week) : item.week) || 'N/A', // [EDITED: KPI Task - Mahesh Sharma]
        'Employee Name': item.employeeName || item.employee_name || 'N/A', // [EDITED: KPI Task - Mahesh Sharma]
        'Submission Date': item.submissionDisplay || item.submissionDate || '-', // [EDITED: KPI Task - Mahesh Sharma]
        'Target Date': item.targetDisplay || item.target_date || '-', // [EDITED: KPI Task - Mahesh Sharma]
        'Workflow Status': item.statusDisplay || item.status || 'Pending', // [EDITED: KPI Task - Mahesh Sharma]
        'Entries Count': item.count || (item.rawKPIs ? item.rawKPIs.length : 1) // [EDITED: KPI Task - Mahesh Sharma]
      })); // [EDITED: KPI Task - Mahesh Sharma]
    } else { // [EDITED: KPI Task - Mahesh Sharma]
      rows = data.map((item, index) => ({ // [EDITED: KPI Task - Mahesh Sharma]
        'S.No': index + 1, // [EDITED: KPI Task - Mahesh Sharma]
        'Week': weekLabel,
        'Employee Code': item.employee_code || item.employee_id || item.EmployeeCode || 'N/A', // [EDITED: KPI Task - Mahesh Sharma]
        'Employee Name': item.employee_name || item.employeeName || item.EmployeeName || 'N/A', // [EDITED: KPI Task - Mahesh Sharma]
        'Department': item.department_name || item.dept_name || item.Department || 'N/A', // [EDITED: KPI Task - Mahesh Sharma]
        'Role': item.role || item.employee_role || item.Designation || 'N/A', // [EDITED: KPI Task - Mahesh Sharma]
        'Reporting Manager / Reviewer': item.team_lead_name || item.reviewer_name || 'N/A', // [EDITED: KPI Task - Mahesh Sharma]
        'Submission Status': item.submission_status || (item.kpi_id || item.id ? 'Submitted' : 'Not Submitted'), // [EDITED: KPI Task - Mahesh Sharma]
        'Rating Status': item.rating_status || (item.TLPoints || item.hod_points ? 'Rated' : 'Pending'), // [EDITED: KPI Task - Mahesh Sharma]
        'Self Points': item.selfPoints !== undefined && item.selfPoints !== null ? item.selfPoints : '-', // [EDITED: KPI Task - Mahesh Sharma]
        'TL Points': item.TLPoints !== undefined && item.TLPoints !== null ? item.TLPoints : '-', // [EDITED: KPI Task - Mahesh Sharma]
        'HOD Points': item.hod_points !== undefined && item.hod_points !== null ? item.hod_points : '-' // [EDITED: KPI Task - Mahesh Sharma]
      })); // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]

    const worksheet = XLSX.utils.json_to_sheet(rows); // [EDITED: KPI Task - Mahesh Sharma]
    const workbook = XLSX.utils.book_new(); // [EDITED: KPI Task - Mahesh Sharma]
    XLSX.utils.book_append_sheet(workbook, worksheet, 'KPI Tracker'); // [EDITED: KPI Task - Mahesh Sharma]

    const weekForFile = (formatFYWeekShort(week) || week || 'report').replace(/\s+/g, '_');
    const safeFilename = `${reportType.replace(/\s+/g, '_')}_${weekForFile}.xlsx`; // [EDITED: KPI Task - Mahesh Sharma]
    XLSX.writeFile(workbook, safeFilename); // [EDITED: KPI Task - Mahesh Sharma]
    return true; // [EDITED: KPI Task - Mahesh Sharma]
  } catch (error) { // [EDITED: KPI Task - Mahesh Sharma]
    console.error('Error exporting KPI to Excel:', error); // [EDITED: KPI Task - Mahesh Sharma]
    throw error; // [EDITED: KPI Task - Mahesh Sharma]
  } // [EDITED: KPI Task - Mahesh Sharma]
} // [EDITED: KPI Task - Mahesh Sharma]

/**
 * Exports KPI Tracker report to a PDF file.
 * Automatically adapts columns whether from Admin Management view or Dashboard/Reports view.
 *
 * @param {Array} data - Array of submission/rating objects
 * @param {string} week - Target week string
 * @param {string} reportType - e.g. "KPI Submissions & Ratings Tracker"
 */
export function exportKPIToPDF(data = [], week = '', reportType = 'KPI Tracker Report') { // [EDITED: KPI Task - Mahesh Sharma]
  try { // [EDITED: KPI Task - Mahesh Sharma]
    if (!data || data.length === 0) { // [EDITED: KPI Task - Mahesh Sharma]
      alert('No data available to export'); // [EDITED: KPI Task - Mahesh Sharma]
      return false; // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]

    const doc = new jsPDF({ orientation: 'landscape' }); // [EDITED: KPI Task - Mahesh Sharma]
    const weekLabel = formatFYWeekLabel(week) || week || 'All Periods'; // [EDITED: KPI Task - Mahesh Sharma]

    // Title and Header Styling // [EDITED: KPI Task - Mahesh Sharma]
    doc.setFontSize(16); // [EDITED: KPI Task - Mahesh Sharma]
    doc.setTextColor(0, 102, 204); // #0066cc // [EDITED: KPI Task - Mahesh Sharma]
    doc.text(`BuildINT BTS - ${reportType}`, 14, 15); // [EDITED: KPI Task - Mahesh Sharma]

    doc.setFontSize(10); // [EDITED: KPI Task - Mahesh Sharma]
    doc.setTextColor(100, 100, 100); // [EDITED: KPI Task - Mahesh Sharma]
    doc.text(`Period: ${weekLabel}  |  Generated on: ${new Date().toLocaleString()}`, 14, 22); // [EDITED: KPI Task - Mahesh Sharma]

    const isManagementView = data.length > 0 && ('employeeName' in data[0] || 'submissionDisplay' in data[0]); // [EDITED: KPI Task - Mahesh Sharma]

    let tableColumns; // [EDITED: KPI Task - Mahesh Sharma]
    let tableRows; // [EDITED: KPI Task - Mahesh Sharma]

    if (isManagementView) { // [EDITED: KPI Task - Mahesh Sharma]
      tableColumns = ['#', 'Week', 'Employee Name', 'Submission Date', 'Target Date', 'Workflow Status', 'Entries']; // [EDITED: KPI Task - Mahesh Sharma]
      tableRows = data.map((item, index) => [ // [EDITED: KPI Task - Mahesh Sharma]
        index + 1, // [EDITED: KPI Task - Mahesh Sharma]
        item.week || 'N/A', // [EDITED: KPI Task - Mahesh Sharma]
        item.employeeName || item.employee_name || 'N/A', // [EDITED: KPI Task - Mahesh Sharma]
        item.submissionDisplay || item.submissionDate || '-', // [EDITED: KPI Task - Mahesh Sharma]
        item.targetDisplay || item.target_date || '-', // [EDITED: KPI Task - Mahesh Sharma]
        item.statusDisplay || item.status || 'Pending', // [EDITED: KPI Task - Mahesh Sharma]
        item.count || (item.rawKPIs ? item.rawKPIs.length : 1) // [EDITED: KPI Task - Mahesh Sharma]
      ]); // [EDITED: KPI Task - Mahesh Sharma]
    } else { // [EDITED: KPI Task - Mahesh Sharma]
      tableColumns = [ // [EDITED: KPI Task - Mahesh Sharma]
        '#', // [EDITED: KPI Task - Mahesh Sharma]
        'Emp Code', // [EDITED: KPI Task - Mahesh Sharma]
        'Emp Name', // [EDITED: KPI Task - Mahesh Sharma]
        'Department', // [EDITED: KPI Task - Mahesh Sharma]
        'Role', // [EDITED: KPI Task - Mahesh Sharma]
        'Manager / Reviewer', // [EDITED: KPI Task - Mahesh Sharma]
        'Submission', // [EDITED: KPI Task - Mahesh Sharma]
        'Rating Status' // [EDITED: KPI Task - Mahesh Sharma]
      ]; // [EDITED: KPI Task - Mahesh Sharma]

      tableRows = data.map((item, index) => [ // [EDITED: KPI Task - Mahesh Sharma]
        index + 1, // [EDITED: KPI Task - Mahesh Sharma]
        item.employee_code || item.employee_id || item.EmployeeCode || 'N/A', // [EDITED: KPI Task - Mahesh Sharma]
        item.employee_name || item.employeeName || item.EmployeeName || 'N/A', // [EDITED: KPI Task - Mahesh Sharma]
        item.department_name || item.dept_name || item.Department || 'N/A', // [EDITED: KPI Task - Mahesh Sharma]
        item.role || item.employee_role || item.Designation || 'N/A', // [EDITED: KPI Task - Mahesh Sharma]
        item.team_lead_name || item.reviewer_name || 'N/A', // [EDITED: KPI Task - Mahesh Sharma]
        item.submission_status || (item.kpi_id || item.id ? 'Submitted' : 'Not Submitted'), // [EDITED: KPI Task - Mahesh Sharma]
        item.rating_status || (item.TLPoints || item.hod_points ? 'Rated' : 'Pending') // [EDITED: KPI Task - Mahesh Sharma]
      ]); // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]

    const options = { // [EDITED: KPI Task - Mahesh Sharma]
      startY: 28, // [EDITED: KPI Task - Mahesh Sharma]
      head: [tableColumns], // [EDITED: KPI Task - Mahesh Sharma]
      body: tableRows, // [EDITED: KPI Task - Mahesh Sharma]
      theme: 'striped', // [EDITED: KPI Task - Mahesh Sharma]
      headStyles: { fillColor: [0, 102, 204], textColor: [255, 255, 255], fontStyle: 'bold' }, // [EDITED: KPI Task - Mahesh Sharma]
      styles: { fontSize: 9, cellPadding: 3 } // [EDITED: KPI Task - Mahesh Sharma]
    }; // [EDITED: KPI Task - Mahesh Sharma]

    if (typeof autoTable === 'function') { // [EDITED: KPI Task - Mahesh Sharma]
      autoTable(doc, options); // [EDITED: KPI Task - Mahesh Sharma]
    } else if (typeof doc.autoTable === 'function') { // [EDITED: KPI Task - Mahesh Sharma]
      doc.autoTable(options); // [EDITED: KPI Task - Mahesh Sharma]
    } // [EDITED: KPI Task - Mahesh Sharma]

    const safeFilename = `${reportType.replace(/\s+/g, '_')}_${week ? week.replace(/\s+/g, '_') : 'report'}.pdf`; // [EDITED: KPI Task - Mahesh Sharma]
    doc.save(safeFilename); // [EDITED: KPI Task - Mahesh Sharma]
    return true; // [EDITED: KPI Task - Mahesh Sharma]
  } catch (error) { // [EDITED: KPI Task - Mahesh Sharma]
    console.error('Error exporting KPI to PDF:', error); // [EDITED: KPI Task - Mahesh Sharma]
    throw error; // [EDITED: KPI Task - Mahesh Sharma]
  } // [EDITED: KPI Task - Mahesh Sharma]
} // [EDITED: KPI Task - Mahesh Sharma]
